<template>
  <!--  批量修改标签操作-->
  <el-dialog title="视频播放"
             :visible.sync="visible"
             width="720px"
             center>
    <div class="content">
      <video :src="url"
             controls
             autoplay></video>
    </div>
    <div slot="footer"
         class="dialog-footer">
      <el-button size="small"
                 type="success"
                 @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: "VideoDialog",
  data() {
    return {
      visible: false,
      url: null
    }
  },
  methods: {
    show(url) {
      this.url = url
      this.visible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  text-align: center;
}
.content video {
  max-height: 50vh;
}
</style>


// WEBPACK FOOTER //
// src/views/pms/components/VideoDialog.vue